const topBar = document.querySelector('[data-top-bar]');
const topMessage = document.querySelector('[data-top-message]');

export default function initStickyHeader() {
    window.addEventListener('scroll', () => {
        if (window.innerWidth >= 768) {
            if (window.scrollY > 250) {
                topBar.classList.add('sticky-header');

                if(topMessage) {
                  topMessage.classList.add('hidden');
                }
            } else {
                topBar.classList.remove('sticky-header');

                if(topMessage) {
                  topMessage.classList.remove('hidden');
                }
            }
        }
    });
}
